$(document).ready(() => {
  $(".marquee").marquee({
    startVisible: true,
  });
  // $(".carousel__marquee-wrapper").marquee({
  //   //duration in milliseconds of the marquee
  //   duration: 20000,
  //   //time in milliseconds before the marquee will start animating
  //   gap: 24,
  //   delayBeforeStart: 0,
  //   //'left' or 'right'
  //   direction: "left",
  //   //true or false - should the marquee be duplicated to show an effect of continues flow
  //   duplicated: true,
  //   startVisible: true,
  // });
  // $(".carousel__marquee").css("visibility", "show");
});
